import _ from 'lodash';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import scrollparent from 'scrollparent';

import connect from 'components/lib/connect';
import { MenuContainer, MenuItem } from 'components/lib/menu_deprecated';
import MenuIcon from 'components/lib/icons/menu_icon';
import PinToCustomerMenu from 'components/customer/conversation_history/conversation_items_v2/menu/pin_to_customer/pin_to_customer_menu';
import { PortalledPopover } from 'components/common/lib/_popover';
import TrackRelationshipClick from 'scripts/application/actions/conversation_item/pin_item/track_relationship_click';
import WindowSizeWatcher from 'components/common/utilities/window_size_watcher';
import ConversationItemType from 'models/conversation_item_type';

export class ConversationItemMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.onClick = this.onClick.bind(this);
  }

  componentDidMount() {
    this.setState({ scrollParent: scrollparent(this.menuContainer.container) });
  }

  onClick(e) {
    this.props.onOpenMenu();
    e.stopPropagation();
  }

  render() {
    return (
      <MenuContainer
        button={this.props.renderButton()}
        className="conversationItemMenu"
        onClick={this.onClick}
        ref={node => (this.menuContainer = node)}
        positionInside={this.state.scrollParent}
      >
        {this.renderAddCommentMenuItem()}
        {this.renderForwardMenuItem()}
        {this.renderReplyMenuItem()}
        {this.renderNoReplyNeededItem()}
        {this.renderVoiceRecordingMenuItems()}
        {this.renderCopyMenuItem()}
        {this.renderMentionMenuItem()}
        {this.renderEditTaskMenuItem()}
        {this.renderFollowTaskMenuItem()}
        {this.renderUnfollowTaskMenuItem()}
        {this.renderReportPoorCallQuality()}
        {this.renderReactionMenuItem()}
      </MenuContainer>
    );
  }

  renderNoReplyNeededItem() {
    if (!this.props.isNoReplyNeededVisible) {
      return null;
    }
    return (
      <MenuItem
        className={classnames('conversationItemMenu-menuItem', 'conversationItemMenu-menuItem-noReplyNeeded')}
        onSelect={this.props.onNoReplyNeeded}
      >
        <span>No Reply Needed</span>
      </MenuItem>
    );
  }

  renderReactionMenuItem() {
    if (this.props.isReactionVisible) {
      return (
        <MenuItem
          className={classnames('conversationItemMenu-menuItem', 'conversationItemMenu-menuItem-reaction')}
          onSelect={this.props.onReaction}
        >
          <span>Like Message</span>
        </MenuItem>
      );
    }
    return null;
  }

  renderForwardMenuItem() {
    if (!this.props.isForwardVisible) {
      return null;
    }
    return (
      <MenuItem
        className={classnames('conversationItemMenu-menuItem', 'conversationItemMenu-menuItem-forward')}
        onSelect={this.props.onForward}
      >
        <span>Forward</span>
      </MenuItem>
    );
  }

  renderReplyMenuItem() {
    if (!this.props.isReplyVisible) {
      return null;
    }
    return (
      <MenuItem
        className={classnames('conversationItemMenu-menuItem', 'conversationItemMenu-menuItem-reply')}
        onSelect={this.props.onReply}
      >
        <span>Reply All</span>
      </MenuItem>
    );
  }

  renderMentionMenuItem() {
    return (
      <MenuItem
        className={classnames('conversationItemMenu-menuItem', 'conversationItemMenu-menuItem-mention')}
        onSelect={this.props.onOpenPinToCustomer}
      >
        <span>Pin To Another Customer</span>
      </MenuItem>
    );
  }

  renderEditTaskMenuItem() {
    if (this.props.contentType === ConversationItemType.TASK && !_.get(this.props, 'item.content.closedAt')) {
      return (
        <MenuItem
          className={classnames('conversationItemMenu-menuItem', 'conversationItemMenu-menuItem-editTask')}
          onSelect={this.props.onEditTask}
        >
          <span>Edit Task</span>
        </MenuItem>
      );
    }
    return null;
  }

  renderAddCommentMenuItem() {
    if (
      !this.props.hideComment &&
      this.props.contentType === ConversationItemType.TASK &&
      !_.get(this.props, 'item.content.closedAt')
    ) {
      return (
        <MenuItem
          className={classnames('conversationItemMenu-menuItem', 'conversationItemMenu-menuItem-addComment')}
          onSelect={this.props.openSidePanel}
        >
          <span>Add a Comment</span>
        </MenuItem>
      );
    }
    return null;
  }

  renderFollowTaskMenuItem() {
    if (this.props.isFollowVisible) {
      return (
        <MenuItem
          className={classnames('conversationItemMenu-menuItem', 'conversationItemMenu-menuItem-followTask')}
          onSelect={this.props.onFollowTask}
        >
          <span>Follow Task</span>
        </MenuItem>
      );
    }
    return null;
  }

  renderUnfollowTaskMenuItem() {
    if (this.props.isUnfollowVisible) {
      return (
        <MenuItem
          className={classnames('conversationItemMenu-menuItem', 'conversationItemMenu-menuItem-unfollowTask')}
          onSelect={this.props.onUnfollowTask}
        >
          <span>Unfollow Task</span>
        </MenuItem>
      );
    }
    return null;
  }

  renderReportPoorCallQuality() {
    if (!this.props.canReportPoorCallQuality) {
      return null;
    }

    return (
      <MenuItem
        key="conversationItemMenu-menuItem-reportPoorCallQuality"
        className="conversationItemMenu-menuItem conversationItemMenu-menuItem-reportPoorCallQuality"
        onSelect={this.props.onReportPoorCallQuality}
      >
        <span>Report Poor Call Quality</span>
      </MenuItem>
    );
  }

  renderVoiceRecordingMenuItems() {
    if (!this.props.canManageVoiceRecordings) {
      return null;
    }
    return [
      <MenuItem
        key="conversationItemMenu-menuItem-downloadRecording"
        className="conversationItemMenu-menuItem conversationItemMenu-menuItem-downloadRecording"
      >
        <a className="conversationItemMenu-menuItem-downloadRecording-url" href={this.props.recordingUrl} download>
          <span>Download Recording</span>
        </a>
      </MenuItem>,
      <MenuItem
        key="conversationItemMenu-menuItem-deleteRecording"
        className="conversationItemMenu-menuItem conversationItemMenu-menuItem-deleteRecording"
        onSelect={this.props.onDeleteRecording}
      >
        <span>Delete Recording</span>
      </MenuItem>,
    ];
  }

  renderCopyMenuItem() {
    return (
      <MenuItem
        className="conversationItemMenu-menuItem conversationItemMenu-menuItem-copyLink"
        onSelect={this.props.onCopyLink}
      >
        <span>Copy Link</span>
      </MenuItem>
    );
  }
}

export class ConversationItemMenuDisplayer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { isPinToCustomerVisible: false };
    this.handleClosePinToCustomer = this.handleClosePinToCustomer.bind(this);
    this.handleOpenPinToCustomer = this.handleOpenPinToCustomer.bind(this);
    this.renderButton = this.renderButton.bind(this);
  }

  render() {
    return (
      <div className={classnames('conversationItemMenuDisplayer', this.props.className)}>
        {this.renderPinToCustomerMenu()}
        {this.renderConversationItemMenu()}
      </div>
    );
  }

  renderButton() {
    return (
      <div
        className="conversationItemMenu-button-container"
        onMouseDown={preventDefault}
        ref={node => (this.button = node)}
      >
        <MenuIcon />
      </div>
    );
  }

  renderConversationItemMenu() {
    if (!this.props.isMenuVisible) {
      return null;
    }

    return (
      <ConversationItemMenu
        {...this.props}
        onOpenPinToCustomer={this.handleOpenPinToCustomer}
        renderButton={this.renderButton}
      />
    );
  }

  renderPinToCustomerMenu() {
    if (!this.state.isPinToCustomerVisible) {
      return null;
    }

    return (
      <WindowSizeWatcher>
        {({ windowHeight, windowWidth }) => (
          <PortalledPopover
            autoPosition
            bounds={{
              bottom: windowHeight - 70,
              right: windowWidth - 10,
              top: 70,
            }}
            className="pinToCustomerMenu"
            isVisible
            position="bottom"
            targetElement={this.button}
          >
            <PinToCustomerMenu
              conversationItemId={this.props.conversationItemId}
              currentCustomerId={this.props.customerId}
              onClose={this.handleClosePinToCustomer}
            />
          </PortalledPopover>
        )}
      </WindowSizeWatcher>
    );
  }

  handleOpenPinToCustomer() {
    this.setState({ isPinToCustomerVisible: true });
    this.props.onOpenRelationshipMenu();
  }

  handleClosePinToCustomer() {
    this.setState({ isPinToCustomerVisible: false });
  }
}

export default connect(null, mapExecuteToProps)(ConversationItemMenuDisplayer);

function mapExecuteToProps(executeAction) {
  return {
    onOpenRelationshipMenu: () => executeAction(TrackRelationshipClick, 'Pin To Customer'),
  };
}

ConversationItemMenuDisplayer.propTypes = {
  canManageVoiceRecordings: PropTypes.bool,
  className: PropTypes.string,
  contentType: PropTypes.string.isRequired,
  conversationItemId: PropTypes.string.isRequired,
  customerId: PropTypes.string.isRequired,
  hideComment: PropTypes.bool,
  isFollowVisible: PropTypes.bool,
  isForwardVisible: PropTypes.bool,
  isMenuVisible: PropTypes.bool,
  isReactionVisible: PropTypes.bool,
  isNoReplyNeededVisible: PropTypes.bool,
  isReplyVisible: PropTypes.bool,
  isUnfollowVisible: PropTypes.bool,
  onDeleteRecording: PropTypes.func,
  onEditTask: PropTypes.func,
  onForward: PropTypes.func,
  onNoReplyNeeded: PropTypes.func,
  onOpenPinToCustomer: PropTypes.func,
  onReaction: PropTypes.func,
  onReply: PropTypes.func,
  recordingUrl: PropTypes.string,
};

ConversationItemMenu.propTypes = {
  ...ConversationItemMenuDisplayer.propTypes,
  renderButton: PropTypes.func.isRequired,
};

function preventDefault(evt) {
  evt.preventDefault();
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/menu/conversation_item_menu.jsx